<template>
  <div>
    <v-tabs
      v-model="tabs"
      dark
      dense
      class="rounded-lg"
      background-color="primary"
      active-class="tab-active"
      slider-color="#ffbc00"
    >
      <v-tab class="font-weight-black">CIERRE DEL AÑO</v-tab>
      <v-tab class="font-weight-black">RECUPERACIÓN</v-tab>
      <v-tab class="font-weight-black">SUBSANACIÓN</v-tab>
      <v-tab class="font-weight-black">HISTORIALES</v-tab>
    </v-tabs>
    <v-tabs-items touchless v-model="tabs">
      <!----------------------------------VISTA DE SITUACIÖN DEL ESTUDIANTE----------------->
      <v-tab-item>
        <CierreAnioSituacionEstudiante :tabPosition="tabs" />
      </v-tab-item>
      <!----------------------------------VISTA DE CIERRE DE NOTAS----------------->
      <!-- <v-tab-item class="mt-2">
        <CierreNotasPeriodo :tab="tabs"/>
      </v-tab-item> -->
      <!----------------------------------VISTA DE PERIODO DE RECUPERACIÓN----------------->
      <v-tab-item>
        <Recuperacion :tabPosition="tabs" />
      </v-tab-item>
      <!----------------------------------VISTA DE CURSOS A CARGO----------------->
      <v-tab-item>
        <CursosACargo :tabPosition="tabs" />
      </v-tab-item>

      <v-tab-item>
        <Historiales :tabPosition="tabs" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import CierreAnioSituacionEstudiante from "./components/CierreAnioSituacionEstudiante.vue";
import CursosACargo from "./components/CursosACargo.vue";
import Recuperacion from "./components/Recuperacion.vue";
import Historiales from "./components/HistorialSituacionFinal.vue";
import { mapMutations } from "vuex";
export default {
  components: {
    CursosACargo,
    CierreAnioSituacionEstudiante,
    Recuperacion,
    Historiales,
  },

  data() {
    return {
      tabs: 0,
    };
  },
  methods: {
    ...mapMutations({
      setEnviarMens: "mensajeSis/setEnviarMens",
    }),
  },
};
</script>
